import { ActionLink } from "./ActionLink";
import { useState } from 'react';

import { Carousel } from './Carousel';
import { useRef, useEffect } from 'react';
import hotspotsData from '../data/hotspots.json';
import { HotspotEditor } from './HotspotEditor';

export function GeckoPage({ copy }) {
  const isDev = import.meta.env.DEV;
  const showEditor = false;
  const [editMode, setEditMode] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(null);
  const [scale, setScale] = useState(1);
  const imageContainerRef = useRef(null);
  const productImageUrl = "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Ff935b924d0924cbab203d110efd41ad5";
  const [hotspots, setHotspots] = useState(hotspotsData);

  const hotspotDetails = Array.from({ length: hotspotsData.length }, (_, i) => ({
    title: `Infrastructure detection ${i + 1}`,
    image: 'https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F1e6a3d41017144ba9af8a7c010c0cb30?format=webp',
    text: `Détection d'infrastructure #${i + 1}`,
  }));

  useEffect(() => {
    if (!isDev) return;
    localStorage.setItem('geckoHotspots', JSON.stringify(hotspots));
  }, [hotspots, isDev]);

  useEffect(() => {
    const container = imageContainerRef.current;
    if (!container) return;

    const measure = () => setScale(container.offsetWidth / 1200);

    measure();
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(container);

    return () => resizeObserver.disconnect();
  }, []);


  return (
    <main className="gecko-page">
      <section className="gecko-hero">
        <div className="gecko-hero-copy">
          <p className="eyebrow">{copy.heroEyebrow}</p>
          <h1>
            imajnet<span className="trademark">®</span> <strong>Gecko</strong>
          </h1>
          <h2>{copy.heroTitle}</h2>
          <div className="hero-logo-wrapper">
            <img
              className="hero-logo"
              src="https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F8dbf766299f2421098d0e74763c339e3?format=webp&width=800&height=1200"
              alt="imajnet logo"
            />
          </div>
          <ActionLink href="https://gecko.imajnet.net/">{copy.login}</ActionLink>
        </div>
      </section>

      <section className="gecko-intro">
        <div
          className="gecko-intro-image"
          role="img"
          aria-label=""
        />
        <div className="gecko-intro-copy">
          {copy.intro.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section className="gecko-features">
        <div className="gecko-features-intro">
          {showEditor && (
            <button
              onClick={() => setEditMode(!editMode)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 1000,
                padding: '8px 16px',
                background: editMode ? '#d20a62' : '#00a4d6',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              {editMode ? '✓ Édition ON' : 'Édition OFF'}
            </button>
          )}
          <div
            ref={imageContainerRef}
            className="product-image"
            style={{
              backgroundImage: `url("${productImageUrl}")`,
              backgroundPosition: "center",
              position: "relative",
            }}
          >
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url("https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fa95289168b8a4c8b91cbea23abe9c232?format=webp")`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              opacity: 0,
              pointerEvents: "none",
              zIndex: 5,
            }}></div>
            {showEditor && editMode && <HotspotEditor hotspots={hotspots} onUpdate={setHotspots} containerRef={imageContainerRef} hotspotDetails={hotspotDetails} scale={scale} />}
            <div className="image-hotspots" style={{ display: 'none' }}>
              {editMode && (
                <style>{`
                  .hotspot-btn {
                    opacity: 1 !important;
                    background: rgba(0, 164, 214, 0.2) !important;
                    border: 2px solid #00a4d6 !important;
                    outline: 1px solid rgba(255, 255, 255, 0.5);
                  }
                  .hotspot-btn::before {
                    content: attr(title);
                    position: absolute;
                    background: rgba(0, 0, 0, 0.9);
                    color: #0f0;
                    padding: 4px 8px;
                    border-radius: 2px;
                    font-size: 10px;
                    white-space: nowrap;
                    top: -25px;
                    left: 50%;
                    transform: translateX(-50%);
                    pointer-events: none;
                    z-index: 1000;
                  }
                `}</style>
              )}
              {hotspots.map((btn, idx) => (
                <div
                  key={idx}
                  className="hotspot"
                  style={{ top: btn.pos.top, left: btn.pos.left }}
                  onMouseEnter={(e) => {
                    const btn = e.currentTarget.querySelector('.hotspot-btn');
                    if (btn) btn.style.opacity = '0.6';
                  }}
                  onMouseLeave={(e) => {
                    const btn = e.currentTarget.querySelector('.hotspot-btn');
                    if (btn) btn.style.opacity = '0';
                  }}
                >
                  <button
                    className="hotspot-btn"
                    title={`Hotspot ${idx + 1}`}
                    onClick={() => setPreviewIndex(idx)}
                    style={{
                      width: btn.shape === "circle" ? `${btn.size * 2 * scale}px` : `${btn.width * 2 * scale}px`,
                      height: btn.shape === "circle" ? `${btn.size * 2 * scale}px` : `${btn.height * 2 * scale}px`,
                      borderRadius: btn.shape === "circle" ? "50%" : "0",
                      background: "rgba(0, 164, 214, 0.3)",
                      border: "2px solid #00a4d6",
                      cursor: "pointer",
                      opacity: 0,
                      transition: "opacity 0.2s",
                      transform: btn.rotation ? `rotate(${btn.rotation}deg)` : undefined,
                    }}
                  >
                    <span className="hotspot-dot" style={{display: "none"}}></span>
                  </button>
                  <div className="hotspot-tooltip"><div className="tooltip-content"><h4>Infrastructure detection :</h4><img src={hotspotDetails[idx]?.image || "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F1e6a3d41017144ba9af8a7c010c0cb30?format=webp"} alt="Detection" /></div></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {copy.features.map((feature, index) => (
          <article
            className={`product-row gecko-feature${index % 2 ? " reverse" : ""}`}
            key={feature.title}
          >
            {index === 0 ? (
              <div
                className="product-image"
                style={{
                  backgroundImage: `url("https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fb2635b9932e245e4b421fb054af57669?format=webp&width=1600&height=2400")`,
                  backgroundPosition: "center",
                }}
              />
            ) : (feature.carouselImages) ? (
              <div className="product-image">
                <Carousel images={feature.carouselImages} />
              </div>
            ) : (
              <div
                className="product-image"
                style={{
                  backgroundImage: `linear-gradient(135deg, rgba(8, 30, 44, 0.04), rgba(8, 30, 44, 0.28)), url("${feature.image}")`,
                  backgroundPosition: feature.imagePosition,
                }}
              />
            )}
            <div className="product-copy">
              {feature.eyebrow && <p className="eyebrow">{feature.eyebrow}</p>}
              <h3>{feature.title}</h3>
              {feature.intro && <p>{feature.intro}</p>}
              <ul className="feature-list">
                {feature.items.map((item) => {
                  if (item.includes('imajing AI')) {
                    return (
                      <li key={item}>
                        {item.split('**imajing AI**')[0]}
                        <strong>imajing AI</strong>
                        {item.split('**imajing AI**')[1]}
                      </li>
                    );
                  }
                  return <li key={item}>{item}</li>;
                })}
              </ul>
            </div>
          </article>
        ))}

        <section className="pillar-grid">
          {copy.pillars.map((pillar) => (
            <article className="pillar" key={pillar.title}>
              <h3>{pillar.title}</h3>
              {pillar.subtitle && <p className="pillar-subtitle">{pillar.subtitle}</p>}
              {pillar.logos && pillar.logos.length > 0 && (
                <div className="pillar-logos">
                  {pillar.logos.map((logo, idx) => (
                    <div key={idx} className="logo-wrapper">
                      {pillar.logoLinks && pillar.logoLinks[idx] ? (
                        <>
                          <a href={pillar.logoLinks[idx]} target="_blank" rel="noreferrer" className="pillar-logo-link">
                            <img src={logo} alt={`${pillar.title} logo ${idx + 1}`} className="pillar-logo" />
                          </a>
                          {pillar.logoLabels && pillar.logoLabels[idx] && (
                            <p className="logo-label">{pillar.logoLabels[idx]}</p>
                          )}
                        </>
                      ) : pillar.logoStoreLinks && pillar.logoStoreLinks[idx] ? (
                        <>
                          <div className={`logo-with-stores ${idx === 0 && !pillar.logoStoreLinks[idx].appStore ? 'playstore-only' : ''}`}>
                            <div className={`store-buttons ${idx === 0 && !pillar.logoStoreLinks[idx].appStore ? 'store-buttons-left' : ''}`}>
                              {pillar.logoStoreLinks[idx].playStore && (
                                <a href={pillar.logoStoreLinks[idx].playStore} target="_blank" rel="noreferrer" className="store-btn playstore-btn" title="Google Play">
                                  <img src="https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fc418c6fe3b644ee58295db3f9f0411bd?format=webp&width=800&height=1200" alt="Google Play" />
                                </a>
                              )}
                              {pillar.logoStoreLinks[idx].appStore && (
                                <a href={pillar.logoStoreLinks[idx].appStore} target="_blank" rel="noreferrer" className="store-btn appstore-btn" title="App Store">
                                  <img src="https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F30ca4ed4cb374c369b382a84a27d746a?format=webp&width=800&height=1200" alt="App Store" />
                                </a>
                              )}
                            </div>
                            <img src={logo} alt={`${pillar.title} logo ${idx + 1}`} className="pillar-logo" />
                          </div>
                          {pillar.logoLabels && pillar.logoLabels[idx] && (
                            <p className="logo-label">{pillar.logoLabels[idx]}</p>
                          )}
                        </>
                      ) : (
                        <>
                          <img src={logo} alt={`${pillar.title} logo ${idx + 1}`} className="pillar-logo" />
                          {pillar.logoLabels && pillar.logoLabels[idx] && (
                            <p className="logo-label">{pillar.logoLabels[idx]}</p>
                          )}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
              <p>{pillar.text}</p>
            </article>
          ))}
        </section>
      </section>

      <section className="gecko-cta section-pad">
        <div>
          <p className="eyebrow">imajnet Gecko</p>
          <h2>{copy.heroTitle}</h2>
        </div>
        <div className="gecko-cta-image-wrapper">
          <a
            href={copy.ctaIconLink}
            target="_blank"
            rel="noreferrer"
            className="gecko-cta-icon-link"
          >
            <img
              className="gecko-cta-icon"
              src="https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F56d574a2d4be4896bf5efa94a8d5fdaa?format=webp&width=800&height=1200"
              alt="Icon"
            />
          </a>
        </div>
        <div className="button-row">
          <ActionLink href="https://gecko.imajnet.net/" secondary>
            {copy.loginCta}
          </ActionLink>
        </div>
      </section>

      {previewIndex !== null && hotspotDetails[previewIndex] && (
        <>
          <div
            onClick={() => setPreviewIndex(null)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1999,
            }}
          />
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'white',
              borderRadius: '8px',
              padding: '24px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              zIndex: 2000,
              maxWidth: '500px',
              textAlign: 'center',
            }}
          >
            <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: '18px' }}>
              {hotspotDetails[previewIndex]?.title}
            </h3>
            <img
              src={hotspotDetails[previewIndex]?.image}
              alt="Hotspot preview"
              style={{
                width: '100%',
                maxHeight: '300px',
                borderRadius: '4px',
                marginBottom: '16px',
              }}
            />
            <p style={{ margin: '0 0 16px 0', color: '#666', fontSize: '14px' }}>
              {hotspotDetails[previewIndex]?.text}
            </p>
            <button
              onClick={() => setPreviewIndex(null)}
              style={{
                padding: '10px 24px',
                background: '#d20a62',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              Fermer
            </button>
          </div>
        </>
      )}
    </main>
  );
}
